import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const FeedbackLinkStyled = styled(Link)`
  display: block;
  text-align: center;
  font-size: ${theme.typography.fontSizes.small};
  color: ${theme.colors.slateGray};
  text-decoration: none;
  padding: ${theme.spacing.md} 0;
  margin-bottom: ${theme.spacing.sm};

  &:hover {
    text-decoration: underline;
  }
`;

export const FeedbackLink = () => {
  const { t } = useTranslation();
  return <FeedbackLinkStyled to="/my-feedback">{t('home.feedback')}</FeedbackLinkStyled>;
};
